import { useState } from "react";
import { useTranslation } from "react-i18next";
import { canv } from "@/canv/global";
import PassActionSvg from "../../../icons/PassAction.svg?react";
import styles from "./PasswordWindow.module.css";

type PasswordWindowLayoutProps = {
    onAction: (password: string) => void | Promise<void>;
};

export const PasswordWindowLayout = ({ onAction }: PasswordWindowLayoutProps) => {
    const [password, setPassword] = useState("");
    const { t } = useTranslation();

    const handleFocus = () => {
        canv.appInterface.inputFocused = 1;
    };
    const handleBlur = () => {
        canv.appInterface.inputFocused = 0;
    };

    return (
        <div className={styles.passwordWindow}>
            <div className={styles.passwordWindowInfo}>
                {t("passwordWindow.titleLine1")}
                <br />
                {t("passwordWindow.titleLine2")}
            </div>
            <div className={styles.passwordWindowPass}>
                <div className={styles.passwordWindowPassField}>
                    <input
                        type="password"
                        className={styles.passwordWindowPassFieldInput}
                        placeholder={t("passwordWindow.placeholder")}
                        onChange={(e) => setPassword(e.target.value)}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        value={password}
                    />
                </div>
                <div className={styles.passwordWindowPassAction} onClick={() => onAction(password)}>
                    <PassActionSvg />
                </div>
            </div>
        </div>
    );
};
